var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "d-flex justify-center align-center pa-4" },
            [
              _vm.loading
                ? _c("v-progress-circular", {
                    attrs: { size: 35, color: "primary", indeterminate: "" }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-row",
        { staticClass: "cutdate" },
        [
          _c(
            "v-col",
            [
              _c("label", [
                _vm._v(" Data de corte: "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cutdate,
                      expression: "cutdate"
                    }
                  ],
                  attrs: { type: "date" },
                  domProps: { value: _vm.cutdate },
                  on: {
                    change: _vm.cutChanged,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.cutdate = $event.target.value
                    }
                  }
                })
              ]),
              _c(
                "v-btn",
                {
                  attrs: { title: "Limpar data de corte" },
                  on: { click: _vm.clearCutdate }
                },
                [
                  _c("img", {
                    staticClass: "icon",
                    attrs: {
                      src: require("@/assets/icons/close.svg"),
                      alt: "Limpar"
                    }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "divpdf" },
        [
          _c("div", { staticClass: "divImagemPrinting" }, [
            _c(
              "button",
              {
                staticClass: "buttonImagemPrinting",
                attrs: { type: "button" },
                on: { click: _vm.downloadPdf }
              },
              [
                _c("v-img", {
                  staticClass: "imagem_printing",
                  attrs: { src: require("../../../assets/icons/printing.svg") }
                })
              ],
              1
            )
          ]),
          _c(
            "vue-html2pdf",
            {
              ref: "html2Pdf",
              staticClass: "html2pdf",
              attrs: {
                "show-layout": false,
                "float-layout": false,
                "enable-download": true,
                "preview-modal": false,
                filename: "filename",
                "pdf-quality": 2,
                "manual-pagination": false,
                "pdf-format": "a4",
                "pdf-orientation": "landscape",
                "paginate-elements-by-height": 800,
                "pdf-content-width": "pdfWidth",
                "html-to-pdf-options": _vm.htmlToPdfOptions
              },
              on: {
                progress: function($event) {
                  return _vm.onProgress($event)
                },
                startPagination: function($event) {
                  return _vm.startPagination()
                },
                hasPaginated: function($event) {
                  return _vm.hasPaginated()
                },
                beforeDownload: function($event) {
                  return _vm.beforeDownload($event)
                },
                hasDownloaded: function($event) {
                  return _vm.hasDownloaded($event)
                }
              }
            },
            [
              _c("template", { slot: "pdf-content" }, [
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { slot: "pdf-item" },
                    slot: "pdf-item"
                  },
                  [
                    _c("v-row", { staticClass: "rowHeader h-hidden" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v(" Pagina 1/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c("v-row", { staticClass: "rowSaldos" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Saldo Bruto")
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.currencyHelper.formatValue(_vm.evolucaoSaldo)
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Saldo Liquido")
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.currencyHelper.formatValue(
                                _vm.evolucaoLiquido
                              )
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Rendimento")
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.currencyHelper.formatValue(
                                _vm.evolucaoRendimento
                              )
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.titulo))
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.evolucaoGanho
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "descricaotitulo" }, [
                      _c("span"),
                      _c("span", [_vm._v(" Rendimento do Portifolio ")])
                    ]),
                    _c("v-row", { staticClass: "rowPortifolio" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Periodo")
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(" Carteira")
                        ]),
                        _c("span", { staticClass: "valor" }, [_vm._v(" CDI")]),
                        _c("span", { staticClass: "valor" }, [_vm._v(" IPCA")])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.monthLabel))
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("mensal.fatia")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.cdi.mensal")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.ipca.mensal")
                              )
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("no Ano")
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("ano.fatia")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.cdi.ano")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.ipca.ano")
                              )
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.titulo_2))
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("doze.fatia")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.cdi.doze")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.ipca.doze")
                              )
                            )
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "card" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("Histórico")
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("geral.fatia")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.cdi.geral")
                              )
                            )
                          )
                        ]),
                        _c("span", { staticClass: "valor" }, [
                          _vm._v(
                            _vm._s(
                              _vm.percentageHelper.formatPercentage(
                                _vm.getEvoTotalPath("cotacoes.ipca.geral")
                              )
                            )
                          )
                        ])
                      ])
                    ]),
                    !_vm.checkDownloadPdf
                      ? _c("v-row", { staticClass: "rowSwitch" }, [
                          _c(
                            "div",
                            { ref: "btnsAtivos", staticClass: "btns-ativos" },
                            [
                              _c(
                                "div",
                                { staticClass: "btn-cdi" },
                                [
                                  _c("v-switch", {
                                    attrs: { checked: "", label: "CDI" },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeSwitch("CDI")
                                      }
                                    },
                                    model: {
                                      value: _vm.switchStateCDI,
                                      callback: function($$v) {
                                        _vm.switchStateCDI = $$v
                                      },
                                      expression: "switchStateCDI"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "btn-ipca" },
                                [
                                  _c("v-switch", {
                                    attrs: { checked: "", label: "IPCA" },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeSwitch("IPCA")
                                      }
                                    },
                                    model: {
                                      value: _vm.switchStateIPCA,
                                      callback: function($$v) {
                                        _vm.switchStateIPCA = $$v
                                      },
                                      expression: "switchStateIPCA"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "btn-dolar" },
                                [
                                  _c("v-switch", {
                                    attrs: { label: "DÓLAR" },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeSwitch("DOLAR")
                                      }
                                    },
                                    model: {
                                      value: _vm.switchStateDOLAR,
                                      callback: function($$v) {
                                        _vm.switchStateDOLAR = $$v
                                      },
                                      expression: "switchStateDOLAR"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "btn-ibovespa" },
                                [
                                  _c("v-switch", {
                                    attrs: { label: "IBOVESPA" },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeSwitch("IBOVESPA")
                                      }
                                    },
                                    model: {
                                      value: _vm.switchStateIBOVESPA,
                                      callback: function($$v) {
                                        _vm.switchStateIBOVESPA = $$v
                                      },
                                      expression: "switchStateIBOVESPA"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "html2pdf__page-break" }),
                    _c("v-row", { staticClass: "rowHeader h-hidden" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v(" Pagina 2/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "v-row",
                      { staticClass: "rowLinhaHeader h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { sm: "12", md: "2", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v(
                                  " Estretégia por " +
                                    _vm._s(_vm.descTypeswitchState)
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { sm: "12", md: "1", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [_vm._v(" Saldo Bruto ")])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { sm: "12", md: "9", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricaotitulo" }, [
                              _c("span", [
                                _vm._v(" Rentabilidade por Estrategia ")
                              ])
                            ]),
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", { staticClass: "mes" }, [
                                          _c("span", [
                                            _vm._v(_vm._s(_vm.monthLabel))
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "1", xs: "12" }
                                      },
                                      [_c("div", [_c("span", [_vm._v("%")])])]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "2", xs: "12" }
                                      },
                                      [_c("div", [_c("span", [_vm._v("R$")])])]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", { staticClass: "meses-12" }, [
                                          _c("span", [_vm._v("12 meses")])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "1", xs: "12" }
                                      },
                                      [_c("div", [_c("span", [_vm._v("%")])])]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "2", xs: "12" }
                                      },
                                      [_c("div", [_c("span", [_vm._v("R$")])])]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", { staticClass: "inicio" }, [
                                          _c("span", [_vm._v("Desde o início")])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "1", xs: "12" }
                                      },
                                      [_c("div", [_c("span", [_vm._v("%")])])]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        attrs: { sm: "12", md: "2", xs: "12" }
                                      },
                                      [_c("div", [_c("span", [_vm._v("R$")])])]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-carteira h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [_vm._v(" Carteira")])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.getEvoTotalPath("saldo")
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta h-hidden",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.getEvoTotalPath(
                                                    "mensal.fatia"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.getEvoTotalPath(
                                                    "mensal.percentual"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.getEvoTotalPath(
                                                    "mensal.valor"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.getEvoTotalPath(
                                                    "doze.fatia"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.getEvoTotalPath(
                                                    "doze.percentual"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.getEvoTotalPath(
                                                    "doze.valor"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.getEvoTotalPath(
                                                    "geral.fatia"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.getEvoTotalPath(
                                                    "geral.percentual"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.getEvoTotalPath(
                                                    "geral.valor"
                                                  )
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-precdi h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v(" Juros Pós(CDI) "),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.percentageHelper.formatPercentage(
                                      _vm.saldoJurosPosCdi.saldo /
                                        _vm.getEvoTotalPath("saldo")
                                    )
                                  )
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna  coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.saldoJurosPosCdi.saldo
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosCdi.mensal
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosCdi.mensal
                                                    .percentual
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPosCdi.mensal
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosCdi.doze
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPosCdi.doze
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosCdi.geral
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPosCdi.geral
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-posinflacao h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v(" Juros Pós(Inflacão) "),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.percentageHelper.formatPercentage(
                                      _vm.saldoJurosPosInflacao.saldo /
                                        _vm.getEvoTotalPath("saldo")
                                    )
                                  )
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna  coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.saldoJurosPosInflacao.saldo
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosInflacao
                                                    .mensal.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosInflacao
                                                    .mensal.percentual
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPosInflacao
                                                    .mensal.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosInflacao.doze
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPosInflacao.doze
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPosInflacao
                                                    .geral.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPosInflacao
                                                    .geral.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-prefixo h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v(" Juros Pré(fixo) "),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.percentageHelper.formatPercentage(
                                      _vm.saldoJurosPre.saldo /
                                        _vm.getEvoTotalPath("saldo")
                                    )
                                  )
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna  coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.saldoJurosPre.saldo
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPre.mensal.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPre.mensal
                                                    .percentual
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPre.mensal.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPre.doze.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPre.doze.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoJurosPre.geral.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoJurosPre.geral.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-livres h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v("Livres "),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.percentageHelper.formatPercentage(
                                      _vm.saldoLivre.saldo /
                                        _vm.getEvoTotalPath("saldo")
                                    )
                                  )
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna  coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.saldoLivre.saldo
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoLivre.mensal.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoLivre.mensal
                                                    .percentual
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoLivre.mensal.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoLivre.doze.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoLivre.doze.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoLivre.geral.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoLivre.geral.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-rendavariavel h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v(" Renda variável "),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.percentageHelper.formatPercentage(
                                      _vm.saldoRendaVariavel.saldo /
                                        _vm.getEvoTotalPath("saldo")
                                    )
                                  ) + " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna  coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.saldoRendaVariavel.saldo
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoRendaVariavel.mensal
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoRendaVariavel.mensal
                                                    .percentual
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoRendaVariavel.mensal
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoRendaVariavel.doze
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoRendaVariavel.doze
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoRendaVariavel.geral
                                                    .fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoRendaVariavel.geral
                                                    .valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      { staticClass: "rowLinha header-cambio h-hidden" },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna",
                            attrs: { md: "1.7", xs: "12" }
                          },
                          [
                            _c("div", { staticClass: "descricao" }, [
                              _c("span", [
                                _vm._v(" Câmbio "),
                                _c("br"),
                                _vm._v(
                                  _vm._s(
                                    _vm.percentageHelper.formatPercentage(
                                      _vm.saldoCambio.saldo /
                                        _vm.getEvoTotalPath("saldo")
                                    )
                                  )
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna  coluna-composta",
                            attrs: { md: "1.3", xs: "12" }
                          },
                          [
                            _c("div", [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.saldoCambio.saldo
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "coluna coluna-composta",
                            attrs: { md: "9", xs: "12" }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "colunas" },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoCambio.mensal.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoCambio.mensal
                                                    .percentual
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoCambio.mensal.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoCambio.doze.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoCambio.doze.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [
                                        _c("div", {}, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.percentageHelper.formatPercentage(
                                                  _vm.saldoCambio.geral.fatia
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "1", xs: "12" }
                                      },
                                      [_vm._v(" --- ")]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "hide column",
                                        attrs: { md: "2", xs: "12" }
                                      },
                                      [
                                        _c("div", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currencyHelper.formatValue(
                                                  _vm.saldoCambio.geral.valor
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "html2pdf__page-break" }),
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { slot: "pdf-item" },
                    slot: "pdf-item"
                  },
                  [
                    _c("v-row", { staticClass: "rowHeader" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v("Pagina 3/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "rentabilidadeGraph panel" },
                      [
                        _c("div", { staticClass: "descricaotitulo" }, [
                          _c("span", [_vm._v(" Rentabilidade ")])
                        ]),
                        _c("MixedLine", {
                          attrs: {
                            input: _vm.acumulado,
                            aplicacao: _vm.aplicacao
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "html2pdf__page-break" }),
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { slot: "pdf-item" },
                    slot: "pdf-item"
                  },
                  [
                    _c("v-row", { staticClass: "rowHeader" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v("Pagina 4/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "descricaotitulo" }, [
                      _c("span", [_vm._v("Liquidez ")])
                    ]),
                    _c(
                      "div",
                      [
                        _c("DataTable", {
                          attrs: {
                            emErro: _vm.liqError,
                            errorMessage: _vm.liqMessage,
                            loading: _vm.loading,
                            calculos: _vm.liquidez
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticClass: "html2pdf__page-break" }),
                    _c(
                      "div",
                      [
                        _c("v-row", { staticClass: "rowHeader" }, [
                          _c(
                            "div",
                            { staticClass: "colHeader01" },
                            [
                              _c("v-img", {
                                staticClass: "imagem_Kristal",
                                attrs: { alt: "", src: _vm.imagemPerfil() }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "colHeader02" }, [
                            _c("span", { staticClass: "titleUserName" }, [
                              _vm._v(" " + _vm._s(_vm.userSelected.name))
                            ])
                          ]),
                          _c("div", { staticClass: "colHeader03" }, [
                            _c("div", { staticClass: "data" }, [
                              _c("div", [
                                _c("span", [
                                  _vm._v(" Pagina 5/8 " + _vm._s(_vm.$hoje))
                                ])
                              ]),
                              _c(
                                "div",
                                [
                                  _c("v-img", {
                                    staticClass: "imagem_calendar",
                                    attrs: {
                                      src: require("../../../assets/icons/calendar_icon.svg")
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ]),
                        _c("AlocacaoTotal", {
                          attrs: {
                            calculos: _vm.rentabilidade.calculos,
                            dozeMeses: _vm.rentabilidade.dozeMeses
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { slot: "pdf-item" },
                    slot: "pdf-item"
                  },
                  [
                    _c("v-row", { staticClass: "rowHeader" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v(" Pagina 6/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      [
                        _c("AtribuicaoEstrategia", {
                          attrs: {
                            calculos: _vm.rentabilidade.calculos,
                            dozeMeses: _vm.rentabilidade.dozeMeses
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "html2pdf__page-break" }),
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { slot: "pdf-item" },
                    slot: "pdf-item"
                  },
                  [
                    _c("v-row", { staticClass: "rowHeader" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v(" Pagina 7/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      [
                        _c("DesempenhoCarteira", {
                          attrs: {
                            calculos: _vm.rentabilidade.calculos,
                            dozeMeses: _vm.rentabilidade.dozeMeses
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "html2pdf__page-break" }),
                _c(
                  "section",
                  {
                    staticClass: "section",
                    attrs: { slot: "pdf-item " },
                    slot: "pdf-item "
                  },
                  [
                    _c("v-row", { staticClass: "rowHeader" }, [
                      _c(
                        "div",
                        { staticClass: "colHeader01" },
                        [
                          _c("v-img", {
                            staticClass: "imagem_Kristal",
                            attrs: { alt: "", src: _vm.imagemPerfil() }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "colHeader02" }, [
                        _c("span", { staticClass: "titleUserName" }, [
                          _vm._v(" " + _vm._s(_vm.userSelected.name))
                        ])
                      ]),
                      _c("div", { staticClass: "colHeader03" }, [
                        _c("div", { staticClass: "data" }, [
                          _c("div", [
                            _c("span", [
                              _vm._v("Pagina 8/8 " + _vm._s(_vm.$hoje))
                            ])
                          ]),
                          _c(
                            "div",
                            [
                              _c("v-img", {
                                staticClass: "imagem_calendar",
                                attrs: {
                                  src: require("../../../assets/icons/calendar_icon.svg")
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "rentabilidadeTable pane h-hidden" },
                      [
                        _c("div", { staticClass: "descricaotitulo" }, [
                          _c("span", [_vm._v(" Histórico de Rentabilidade ")])
                        ]),
                        _c(
                          "div",
                          { key: _vm.atualizacao, staticClass: "rows" },
                          _vm._l(_vm.dados, function(item) {
                            return _c(
                              "div",
                              { key: item.ano, staticClass: "row" },
                              [
                                _c("div", { staticClass: "group ano" }, [
                                  _c("div", { staticClass: "cell" }, [
                                    _c("div", [_vm._v("Mês")]),
                                    _c("div", [_vm._v(_vm._s(item.ano))]),
                                    _c("div", [
                                      _vm._v("% " + _vm._s(_vm.indice))
                                    ])
                                  ])
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "group data" },
                                  _vm._l(item.items, function(child, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "cell display"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(_vm._s(_vm.months[index]))
                                        ]),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              (child &&
                                                _vm.format(child.taxa)) ||
                                                "-"
                                            )
                                          )
                                        ]),
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(
                                              (item.comparado[index] &&
                                                _vm.format(
                                                  item.comparado[index].taxa
                                                )) ||
                                                "-"
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _c("div", { staticClass: "group total" }, [
                                  _c("div", { staticClass: "cell" }, [
                                    _c("div", [_vm._v("Anual")]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.format(item.anual.carteira))
                                      )
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.format(item.anual.comparado))
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "cell" }, [
                                    _c("div", [_vm._v("Acum.")]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.format(item.total.carteira))
                                      )
                                    ]),
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.format(item.total.comparado))
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }